import React from 'react';
import {
  FDContentContainer, FDPrimaryActionButton, FDStack,
} from '@facet-wealth/design';
import {
  WorkflowLayout,
} from 'Components/ComponentLibrary/Organisms/WorkflowLayout/WorkflowLayout';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useUserContext from 'Context/UserContext';
import useHomeContext from 'Context/HomeContext';
import fr from 'facet-rest';
import { navigateTo } from 'Helpers/Redirect';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { dataAttrs } from 'Helpers/Testing';
import { ContactSupportAlert } from 'Views/Authentication/Components';
import { useRefreshAuthenticationFactors } from 'Hooks/useRefreshEvent';
import { AuthnMfaResetLayoutAuthFactorList } from './AuthnMfaResetLayoutAuthFactorList';

export const AuthnMfaResetLayout = ({ refreshAuthCollection }) => {
  const { resource } = useMetaLayoutContext();
  const { updateUserResource } = useUserContext();
  const { refreshHomeResource } = useHomeContext();
  const [loading, setLoading] = React.useState(false);

  useRefreshAuthenticationFactors(() => {
    refreshAuthCollection();
  }, [refreshAuthCollection]);

  const onClick = async () => {
    setLoading(true);

    await resource.submit();
    const homeResource = await refreshHomeResource();

    await homeResource.withRelationship(fr.relationships.user.name, async (rel) => {
      const [userResource] = await rel.link('related').get();
      updateUserResource(userResource);
    }, () => {
      // no-op -- re-routed back to login page
    });

    navigateTo('/');
  };

  return (
    <WorkflowLayout appearance={'elevated'} alwaysShowFacetLogo resource={resource}>
      <FDContentContainer maxWidth="sm">
        <FDStack direction={'column'} spacing={2} alignItems={'center'}>
          <MetaControlField attr={'title'} />
          <MetaControlField attr={'description'} />
          <MetaControlField attr={'message'} />
          <AuthnMfaResetLayoutAuthFactorList />
          <FDPrimaryActionButton
            {...dataAttrs('continue-btn', resource)}
            disabled={loading || !resource.meta().canSubmit()}
            label={resource.attr('primaryActionLabel')}
            onClick={onClick}
          />
          <ContactSupportAlert />
        </FDStack>
      </FDContentContainer>
    </WorkflowLayout>
  );
};
